/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonId200,
  GetApiV1PersonId401,
  GetApiV1PersonId404,
  GetApiV1PersonId500,
  GetApiV1PersonIdPathParams,
  GetApiV1PersonIdQueryResponse,
} from "../../types/personRegisterController/GetApiV1PersonId.ts";
import { personDetailViewModelSchema } from "../personDetailViewModelSchema.ts";

export const getApiV1PersonIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1PersonIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonId200Schema = z.lazy(
  () => personDetailViewModelSchema,
) as unknown as ToZod<GetApiV1PersonId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonId401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PersonId404Schema =
  z.any() as unknown as ToZod<GetApiV1PersonId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonId500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonId500>;

export const getApiV1PersonIdQueryResponseSchema = z.lazy(
  () => getApiV1PersonId200Schema,
) as unknown as ToZod<GetApiV1PersonIdQueryResponse>;
